import { useState } from "react";
import { getConsent, setConsent } from "../lib/analytics";
import Button from "./ui/Button";
import "./css/consent_banner.css";

export default function ConsentBanner() {
  const [decided, setDecided] = useState(() => getConsent() !== null);

  if (decided) return null;

  const decide = (value) => {
    setConsent(value);
    setDecided(true);
  };

  return (
    <div className="rl-consent" role="dialog" aria-label="Cookie consent">
      <p className="rl-consent-text">
        We use analytics cookies to understand how visitors use RemboList.
        See our <a href="/privacy">Privacy Policy</a> for details.
      </p>
      <div className="rl-consent-actions">
        <Button variant="tertiary" size="sm" onClick={() => decide("denied")}>Decline</Button>
        <Button variant="primary" size="sm" onClick={() => decide("granted")}>Accept</Button>
      </div>
    </div>
  );
}
